import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class CompanyInforService {
    constructor(private http: HttpClient){
    }
    

    getCompanyInfor() {
        return this.http.get(`${environment.apiUrl}/api/other/setup-tools/company/get-list-company`);
    }
    
    saveCompanyInfor(data){
        return this.http.post(`${environment.apiUrl}/api/other/setup-tools/company/save`, data);
    }
    
}
